import React, { useEffect, useState } from 'react';
import BannerWomanImage from 'assets/banner-woman.png';

const words = ['change the world', 'impact communities', 'solve real problems', 'build legacies'];

export const Banner = () => {
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false); // Start fade out
      setTimeout(() => {
        setCurrentWordIndex((prev) => (prev + 1) % words.length);
        setFade(true); // Fade back in
      }, 500); // Fade-out duration
    }, 4000); // Total duration per word

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="bg-white w-full py-12 px-6 md:px-16 flex flex-col md:flex-row items-center justify-between">
      {/* Left Section */}
      <div className="w-full md:w-1/2 text-center md:text-left mb-10 md:mb-0">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-semibold text-gray-800 leading-snug">
          Impact-driven{' '}
          <span className="relative inline-block">
            entrepreneurs
            <svg
              className="absolute bottom-0 left-0 w-full h-2"
              viewBox="0 0 200 20"
              preserveAspectRatio="none"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0,10 C40,30 160,-10 200,10"
                stroke="#16a34a"
                strokeWidth="4"
                fill="none"
                strokeLinecap="round"
              />
            </svg>
          </span>{' '}
          growing companies that{' '}
          <span
            className={`font-bold text-green-600 transition-opacity duration-500 ${
              fade ? 'opacity-100' : 'opacity-0'
            }`}
          >
            {words[currentWordIndex]}
          </span>
        </h1>
      </div>

      {/* Right Section - Image */}
      <div className="w-full md:w-1/2 flex justify-center md:justify-end">
        <img
          src={BannerWomanImage}
          alt="Banner Woman"
          className="max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg w-full h-auto"
        />
      </div>
    </section>
  );
};
